import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
class FinanceService {
  DoGetBankAccountViewDetail(_input: Array<number>) {
    const input = {
      bankAccountIds: _input,
    };
    return service.peakExportAPI
      .post("/api/Finance/GetBankAccountViewDetail", input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new FinanceService();
